import React from 'react'

const CookiePolicy = () => {
  return (
    <div className="my-10">
      <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto max-w-[37.5rem] text-center mb-10">
              <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">Cookie Policy</h1>
          </div>
      </div>
      <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="md:max-w-screen-sm lg:max-w-[992px] px-4 sm:px-6 lg:px-8 pb-12 md:pt-6 sm:pb-20 mx-auto">
              <div className="grid gap-4 md:gap-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-2">How We Use Cookies</h2>
                <p className="mb-5">We use cookies for a variety of reasons detailed below. Unfortunately, in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave all cookies turned on if you are not sure whether you need them or not in case they are used to provide a service that you use.</p>
                <h2 className="text-lg sm:text-xl font-semibold mb-2">Disabling Cookies</h2>
                <p className="mb-5">You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of this site. Therefore, it is recommended that you do not disable cookies.</p>
                <h2 className="text-lg sm:text-xl font-semibold mb-2">First Party Cookies</h2>
                <p className="mb-5">The iorad website and Application may place cookies on your browser in order to identify you when you return to our website or log in to our platform. We set cookies related to account creation, login, email communications, and forms.</p>
                <h2 className="text-lg sm:text-xl font-semibold mb-2">Third Party Cookies</h2>
                <p className="mb-5">We use only a few third party cookies. We use HubSpot, LinkedIn, and Google's cookies to track our marketing efforts. We use Intercom to provide customer service via chat on our website, and inside our iorad application.</p>
                <h2 className="text-lg sm:text-xl font-semibold mb-2">Cookie We Use</h2>
                <div className="relative overflow-x-auto">
                  <table className="w-full text-sm text-left text-gray-500">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3">Name</th>
                          <th scope="col" className="px-6 py-3">Provider</th>
                          <th scope="col" className="px-6 py-3">Purpose</th>
                          <th scope="col" className="px-6 py-3">Expiration</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr className="bg-white border-b">
                            <th scope="row" className="px-6 py-4 font-medium">gapi_oauth</th>
                            <td className="px-6 py-4">iorad</td>
                            <td className="px-6 py-4">Essential</td>
                            <td className="px-6 py-4">Session</td>
                          </tr>
                          <tr className="bg-white border-b">
                            <th scope="row" className="px-6 py-4 font-medium">integration_oauth</th>
                            <td className="px-6 py-4">iorad</td>
                            <td className="px-6 py-4">Essential</td>
                            <td className="px-6 py-4">Session</td>
                          </tr>
                          <tr className="bg-white border-b">
                            <th scope="row" className="px-6 py-4 font-medium">iorad/redux/modules/tutorials[v3]</th>
                            <td className="px-6 py-4">iorad</td>
                            <td className="px-6 py-4">Essential</td>
                            <td className="px-6 py-4">Session</td>
                          </tr>
                          <tr className="bg-white border-b">
                            <th scope="row" className="px-6 py-4 font-medium">last_connection</th>
                            <td className="px-6 py-4">iorad</td>
                            <td className="px-6 py-4">Essential</td>
                            <td className="px-6 py-4">Session</td>
                          </tr>
                      </tbody>
                  </table>
                </div>
              </div>
          </div>
      </div>
  </div>
  )
}

export default CookiePolicy;